"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var ga_1 = require("../../../utils/ga");
var signup_modal_1 = require("../utils/signup-modal");
var hooks_1 = require("preact/hooks");
var SignupContext_1 = require("../SignupContext");
var SignUpStep3 = function (_a) {
    var email = _a.email, phone = _a.phone, handlePhoneChange = _a.handlePhoneChange;
    var _b = (0, hooks_1.useContext)(SignupContext_1.SignupContext), formStep = _b.formStep, setFormStep = _b.setFormStep;
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("p", { class: "signup-modal__eyebrow signup-modal__eyebrow--step-2" },
            "Don't want to ",
            (0, preact_1.h)("br", { class: "hide-on-desktop" }),
            " miss an offer?"),
        (0, preact_1.h)("div", { class: "signup-modal__enter" },
            (0, preact_1.h)("p", null,
                "Enter your phone number",
                (0, preact_1.h)("br", null),
                "to receive SMS alerts.")),
        (0, preact_1.h)("p", { class: "signup-modal__policies signup-modal__policies--step-2" }, "By submitting this form and clicking SIGN UP, you agree to receive recurring automated promotional and personalized marketing SMS text messages from O Positiv. Please add us to your contact list to make sure you receive our messages. Consent is not a condition of any purchase. Message and data rates may apply. Message frequency varies. You can reply at anytime to STOP to cancel."),
        (0, preact_1.h)("form", { class: "signup-modal__form", onSubmit: function (event) {
                event.preventDefault();
                (0, signup_modal_1.createClientSubscription)(email, 'Wc4keZ', '', 'intro15', phone);
                (0, ga_1.sendEvent)('ce_sign_up_sms');
                setFormStep(3);
                window.localStorage.setItem('completedPopup', 'true');
            } },
            (0, preact_1.h)("input", { class: "signup-modal__input", minLength: 14, maxLength: 14, onInput: function (event) { return handlePhoneChange(event); }, placeholder: "Phone Number", type: "tel", value: phone, required: true }),
            (0, preact_1.h)("button", { class: "signup-modal__button signup-modal__button--sms", type: "submit" }, "SIGN UP")),
        (0, preact_1.h)("div", { class: "signup-modal__step" },
            "Step ",
            formStep,
            " of 2"),
        (0, preact_1.h)("button", { class: "signup-modal__cancel", onClick: function () {
                setFormStep(3);
                window.localStorage.setItem('completedPopup', 'true');
            } }, "No Thanks")));
};
exports.default = SignUpStep3;
